import textServices from "services/text-services"

const NoPosition = () => {
  return (
    <div className='ranking__no-position'>
      <p>
        Aún no has ganado puntos, participa de alguna dinámica.
      </p>
    </div>
  )
}

const Position = ({ ranking }: { ranking?: any }) => {
  if (!ranking?.currentPosition) {
    return <NoPosition />
  }

  return (
    <div className='ranking__position'>
      <div className='ranking__position__current'>
        <h2>
          Estás en la posición <span>{ranking?.currentPosition?.id ?? "-"}</span>
        </h2>
      </div>
      <div className='ranking__position__separator'></div>
      <div className='ranking__position__points'>
        <h2>
          {ranking?.currentPosition?.points ?? "-"} {textServices.findByText('ranking/position/points', 'puntos')}
        </h2>
      </div>
    </div>
  )
}

export default Position